import { createFileRoute } from '@tanstack/react-router';
import { KnowledgeLibraryRouteView } from '@/pages/workspaces/settings/knowledge-library/knowledge-library-route-view';

export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/settings/knowledge_library')({
  component: KnowledgeLibraryRouteView,
});
